module.exports = __webpack_public_path__ + "img/check.29785af4.png";